export const SENTRY_DSN =
  "https://96631541e2f1d099b090e899572a807e@o605776.ingest.us.sentry.io/4509843669909504";
